/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { PreviewFormatter } from "./PreviewFormatter";
export { LEGACY_RECORDING_STATUS, recordingScheduled } from "./recordingEvents";
export type { TRecordingScheduled } from "./recordingEvents";
export { resolveInternalRatingNames } from "./internalRatings";
export type { TInternalRatingRef } from "./internalRatings";
export {
  CarouselTemplate,
  getTileDimensions,
  getTilePixelDimensions,
  getTileTotalHeightVw,
  TILE_DIMENSION_MAP,
  DEFAULT_TILE_DIMENSIONS,
  CarouselTemplateMapper
} from "./CarouselTemplateUtil";
export type {
  TTileDimensions,
  TTilePixelDimensions
} from "./CarouselTemplateUtil";
export {
  mapContentDetailSeed,
  mapPlayableContentDetailSeed
} from "./contentDetailSeedMapper";
export {
  isSmartSearchChannelRail,
  mapSmartSearchCarouselToRail,
  mapSmartSearchFeedItem
} from "./smartSearchCarouselMapper";
export {
  getImageHostBaseUrl,
  clearSmartCarouselApiCache,
  buildScreenGetParams,
  buildCarouselGetParams,
  handleTileSelectionPlayback,
  handleTileSelection,
  openContentDetail,
  resolveTileSelectionDestination,
  TileSelectionDestination,
  fetchCarouselTilePage
} from "./smartCarouselUtility";
export type { TTileNavigateTo } from "./smartCarouselUtility";
export { interpolateLocaleTemplate } from "./localeTemplate";
export { scrollIntoView } from "./scrollIntoView";
export { scrollByWheel } from "../../model/utility/scrollByWheel";
export type { IScrollIntoViewOptions, TScrollBlock } from "./scrollIntoView";
export {
  createLoadMoreTilesThunk,
  isNetworkError
} from "./carouselThunkFactory";
export {
  buildContentHighlightedFields,
  type TContentHighlightedFieldParams
} from "./carouselAnalyticsFields";
export type {
  TLoadMoreTilesPayload,
  TLoadMoreTilesThunkConfig
} from "./carouselThunkFactory";
